import { render, staticRenderFns } from "./EmbeddedVimeoVideo.vue?vue&type=template&id=1d1bb78e&scoped=true&"
import script from "./EmbeddedVimeoVideo.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedVimeoVideo.vue?vue&type=script&lang=ts&"
import style0 from "./EmbeddedVimeoVideo.vue?vue&type=style&index=0&id=1d1bb78e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1bb78e",
  null
  
)

export default component.exports